import { useComponentInViewport } from 'core-lib/hooks/useComponentInViewport';
import { useEffect, useRef } from 'react';
import { Typography } from 'ui-v2/components/Typography';
import { LayoutEntityType, LayoutPropType } from '../../../types/layout';
import { trackSectionViewedStoreV2 } from '../../../utils/events';
import ProductCard from '../../Cards/ProductCard';
import s from './ScrollListing.module.scss';
import useStoreItemClick from '../../../hooks/useStoreItemClick';

export const ScrollListing = ({ data }: LayoutPropType) => {
  //const
  const rootRef = useRef();
  const isEventFired = useRef(false);
  const inViewPort = useComponentInViewport(rootRef, {
    threshold: 0.5,
  });

  const { handleItemClickWithDelegation } = useStoreItemClick();
  const CARDID = data.entityType || 'PRODUCT';

  useEffect(() => {
    if (inViewPort && !isEventFired.current) {
      trackSectionViewedStoreV2(data?.title);
      isEventFired.current = true;
    }
  }, [data?.title, inViewPort]);
  if (!data || !data?.data?.length) return;
  return (
    <div
      className={s.root}
      ref={rootRef}
      onClick={(e) =>
        handleItemClickWithDelegation(
          e,
          CARDID,
          data?.entityType || LayoutEntityType.Product,
          data?.data,
          data?.title
        )
      }
    >
      <div className={s.top}>
        <Typography label={data?.title} variant="label_1_bold" className={s.title} />
        {/* key panding from backend */}
        {/* <Button label="View all" variant="PrimaryNaked" /> */}
      </div>
      <div className={s.container}>
        {data?.data?.map((item, index) => (
          <div key={item?.productSku} className={s.item}>
            <ProductCard
              product={item}
              section={data?.title}
              id={CARDID}
              position={index}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
